import {
  OreTable,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { Step2Form } from '@/Contract/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

type Step2FormKeys = keyof Step2Form

export const ContractNewProductsStep3Resume = (): JSX.Element => {
  const { t } = useTranslation()
  const { getCurrentStepForm } = useContractNewProducts()

  const form = getCurrentStepForm(2) as UseFormReturn<Step2Form>

  const displayFields: Step2FormKeys[] = [
    'name',
    'surname1',
    'documentType',
    'documentNumber',
    'phone',
    'email',
  ]

  const documentTypeTranslation = {
    1: t(formTranslation.common.identifier.documentType.dni),
    2: t(formTranslation.common.identifier.documentType.passport),
  }

  return (
    <OreTableContainer>
      <OreTable>
        <OreTableCaption
          title={t(productContractingTranslation.contractProductPage.step3.resume.title)}
        />
        <OreTableBody>
          {displayFields.map((field, index) => {
            if (field === 'documentNumber' && !form.getValues(field)) return null

            return (
              <OreTableRow key={index}>
                <OreTableCell align="left">
                  <OreText align="left">
                    {t(
                      productContractingTranslation.contractProductPage.step2.form.data[
                        field as keyof typeof productContractingTranslation.contractProductPage.step2.form.data
                      ]?.label,
                    )}
                  </OreText>
                </OreTableCell>

                <OreTableCell align="right">
                  <OreText bold align="right">
                    {field === 'documentType'
                      ? documentTypeTranslation[form.getValues(field) || 1]
                      : form.getValues(field)}
                  </OreText>
                </OreTableCell>
              </OreTableRow>
            )
          })}
        </OreTableBody>
      </OreTable>
    </OreTableContainer>
  )
}
